import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Globals } from 'projects/core/src/globals';
import { Model } from 'projects/core/src/include/model';
import { UserService } from 'projects/core/src/lib/user.service';
import { DocumentDetail } from '../../../db/documents';
import { Project } from '../../../db/project';
import { AddressesService } from '../../../services/addresses.service';
import { DocumentsService } from '../../../services/documents.service';
import { ProjectsService } from '../../../services/projects.service';
import { AddressDetailsComponent } from '../../address/address-details/address-details.component';
import { AddressComponent } from '../../address/address.component';
import { DocumentlistComponent } from '../../documents/documentlist/documentlist.component';
import { DocumentsDetailsComponent } from '../../documents/documents-details/documents-details.component';
import { Helper } from 'projects/core/src/helper';
import { typeOf } from 'mathjs';

@Component({
  selector: 'app-project-detail',
  templateUrl: './project-detail.component.html',
  styleUrls: ['./project-detail.component.css']
})
export class ProjectDetailComponent extends Model<Project> implements OnInit {
  
  @ViewChild("incominglist")
  documentList:DocumentlistComponent;

 
  @ViewChild("costlist")
  costList:DocumentlistComponent;

  modulename="project";

  @Input()
  id_address:number=0;

  get currentUser(){
    return Globals.user;
  }

  shops=[];
  users=[];
  total:any;

  field_required=["id_address","date"];
  
  constructor(
    private route1: ActivatedRoute,
    private projectsService: ProjectsService,
    private userService:UserService,
    public addressesService:AddressesService,
    private documentsService:DocumentsService,

  ) { 
    super(route1,projectsService);    
  }


  ngOnInit(): void {
    super.ngOnInit.apply(this, arguments);
    
    if(this.mode!="modal") {
      this.route1.params.subscribe((params) =>{
        this.id = params.id;
        if(params.id_address>0)
          this.id_address=params.id_address;      
      });
    }      

    this.record=new Project();

    const default_address = Globals.parameters.get("general").getParam("default_address",0);

    this.record.date = Helper.convertDateControl();
    this.record.phase = 1;

    this.userService.getUsers().subscribe((items)=>{
      this.users=items;
    });      

    this.afterGetItem=()=>{        
    }

    this.getItem();
  }

  // Seleziona un'anagrafica per il progetto aprendo la modale di ricerca
  selectAddress(){
    Globals.modal.showModal(AddressComponent,[
      {"name":"mode","value":"modal"},
      {"name":"title","value":"Seleziona un'anagrafica"}
      ],(instance)=>{
      let r=instance['recordSelected'];
      this.OnSelectAddress(r);
    });
  }

  // Seleziona un'anagrafica e chiude la modale
  OnSelectAddress(r){
    if(r){
      this.record.addressItem=r;
      this.record.id_address=r.id;
    }
  }

  // Visualizza i dettagli dell'anagrafica collegata al progetto
  OnViewAddress(r){
    Globals.modal.showModal(AddressDetailsComponent,[
      {"name":"mode","value":"modal"},
      {"name":"id","value":r.id}
    ],(instance)=>{
      if(instance!=null)
        this.OnSelectAddress(instance['record']);
    });
  }  

  // Crea un nuovo documento collegato al progetto
  addDocument(id_type:number=1,typedocument:number=1){

    //crea il dettaglio fattura
    let details:DocumentDetail[]=[];
    let dd:DocumentDetail=new DocumentDetail();
    dd.id_product=0;
    dd.description="Compenso";
    dd.quantity=1;
    dd.tax=parseFloat(Globals.parameters.get("general").getParam("default_tax",22));
    dd.netprice=this.record.amount;
    dd.discount1=0;
    dd.discount2=0;
    dd.discount3=0;    
    details.push(dd);

    Globals.modal.showModal(DocumentsDetailsComponent,[
      {"name":"mode","value":"modal"},
      {"name":"id_table","value":this.record.id},
      {"name":"table","value":"project"},
      {"name":"autoUnload","value":false},
      {"name":"typedocument","value":typedocument},      
      {"name":"id_type","value":id_type},
      {"name":"id_address","value":this.record.id_address},
      {"name":"description","value":""},
      {"name":"description2","value":this.record.name},
      {"name":"details","value":details}    
      
    ],()=>{

      if (id_type == 1) {
        this.documentList.updateList();
      } else {
        this.costList.updateList();
      }

    });

  }

  // Collega un documento esistente
  linkDocument(id_type){
    Globals.modal.showModal(DocumentlistComponent,[
      {"name":"mode","value":"modal"},
      {"name":"selecttype","value":"multiple"},
      {"name":"type","value":id_type}
    
    ],(instance:any)=>{
      
      if(instance!=null){
         let records=instance['recordSelected'];
         if(typeof(records)=="object"){
          records=[records];
         }
       
        for(let i=0;i<records.length;i++){
          const d = records[i];
          d.id_table=this.record.id;
          d.table="project";
          this.documentsService.save(d,()=>{
             if(id_type == 1)
              this.documentList.updateList();
            else
              this.costList.updateList();
          });
        }        
      }
    });
  }


}